var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"multi-user-label"},[_vm._v(" "+_vm._s(_vm.names)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }